import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class AuthService {
    token = localStorage.getItem('token_login');
    public previusErrorAuth = false;

    constructor(private router: Router,
                private http: Http) { 
                    setInterval(() => {
                        if (this.token) {
                            this.checkToken();
                        }
                    }, 5000)
                }

    public loginUser (url, data) {
        return this.http.post(url, data)
                .toPromise()
                .then(res =>  {
                    if (res.status === 200) {
                        this.setToken(res.json().super_admin_token);
                        this.router.navigate(['/dashboard']);
                    } else {
                        this.router.navigate(['/login']);
                            return;
                    }
                    return res;
                        })
                        .catch(error => {
                            return error;
                        })
    }

    private setToken(token) {
        localStorage.setItem('token_login', JSON.stringify(token));
        this.token = JSON.stringify(token);
    }

    public isLoggedUser() {
        let isLogged = false;
        if (this.token && localStorage.getItem('token_login')) {
            isLogged = true;
        }

        return (isLogged);
    }

    private checkToken() {
        if (!this.isLoggedUser()) {
            this.logoutUser()
        }
    }

    public logoutUser() {
        this.token = '';
        localStorage.clear();
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/auth.service.ts